const craftsman_task = {
	name: 'Handwerkerauftrag | Handwerkeraufträge',
	icon: 'fas fa-hammer',
	fields: {
		hp_id: 'ID',
		building: {
			name: '@:entity.building.name',
		},
		first_unit: {
			position: '@:entity.unit.fields.position',
		},
		to_occur: '@:common.toOccur',
		subject_type: 'Art',
		subject: '@:common.subject',
		status: {
			name: 'Status',
		},
	},
}

export default craftsman_task
